import { BotMessages } from "./backend/reply-parsed";

// Images need to be preloaded, otherwise they will pop up very ugly after the bubble text is shown. This also messes with the scroll down logic.
// The scroll down function is called, but the images finish loading afterwards, increasing the bubble size resulting in not being scrolled down fully.
const loadImage = (src: string): Promise<void> =>
    new Promise<void>((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve();
        image.onerror = () => reject(new Error("Image failed to Load!"));
        image.src = src;
    });

const extractImageSrcs = (messages: BotMessages): string[] =>
    messages
      .map((message) => {
        if ("img" in message) {
          return message.img;
        }
        return undefined;
      })
      .filter((src): src is string => typeof src === "string");

export const preloadImages = (messages: BotMessages): Promise<void> => {
    const srcs = extractImageSrcs(messages);
    return Promise.all(srcs.map(loadImage)).then(() => undefined);
};

export function getSrcValues(text: string): string[] {
    return Array.from(
        new DOMParser()
            .parseFromString(text, "text/html")
            .querySelectorAll("img")
    ).map((img) => img.src);
}
